import { get, set } from "idb-keyval";
import Papa from "papaparse";
import { BASE_URL } from "../constants";
import { getAuthHeader } from "../utils";

/**
 * Calcula el timestamp del próximo domingo a las 00:00
 */
function getNextSundayTimestamp() {
    const now = new Date();
    const dayOfWeek = now.getDay();
    // Si hoy es domingo, sumar 7 días para el próximo domingo
    const daysUntilSunday = dayOfWeek === 0 ? 7 : 7 - dayOfWeek;
    const nextSunday = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + daysUntilSunday,
        0, 0, 0, 0
    );
    return nextSunday.getTime();
}

/**
 * Obtiene los requerimientos, usando IndexedDB como caché semanal.
 * @returns {Promise<Array<Object>>}
 */
export async function getCachedRequirementList() {
    try {
        const cacheKey = "requirementList";
        const cacheMetaKey = "requirementListMeta";
        const cached = await get(cacheKey);
        const meta = await get(cacheMetaKey);

        const now = Date.now();
        let mapped;

        // console.log('getCachedRequirementList called');

        if (cached && meta && meta.expiry > now) {
            mapped = cached;
        } else {
            const response = await fetch(`${BASE_URL}insurance/export-requirements-csv/`, {
                headers: {
                    ...getAuthHeader(),
                },
            });

            if (!response.ok) throw new Error("No se pudo descargar el CSV de requerimientos");
            const csvText = await response.text();

            const { data } = Papa.parse(csvText, { header: true, skipEmptyLines: true });

            mapped = data.map((item, idx) => ({
                id: item.id || idx,
                requirement: item.requirement,
                requirement_name: item.requirement_name,
                type_requirement_name: item.type_requirement_name,
                type_requirement: item.type_requirement,
            }));

            await set(cacheKey, mapped);
            await set(cacheMetaKey, { expiry: getNextSundayTimestamp() });
        }

        return mapped;

    } catch (error) {
        console.error("Error fetching requirement list: ", error);
        return [];
    }
}

export async function getClientList() {

    try {

        // Fetch the list of clients from the API
        const response = await fetch(`${BASE_URL}insurance/company-client-users/`, {
            method: "GET",
            headers: {
                ...getAuthHeader(),
                "Content-Type": "application/json",
            },
        });

        const responseData = await response.json();

        if (!response.ok) {
            throw new Error(JSON.stringify(responseData));
        }

        // Return the processed data
        return {
            type: "success",
            message: "Lista de clientes obtenida exitosamente",
            data: responseData,
        };

    } catch (error) {
        console.error("Error fetching client list: ", error);
        return {
            type: "error",
            message: "Error obteniendo la lista de clientes",
            data: [],
        };
    }
}